package com.kinoshazam.screens.main.host

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.kinoshazam.config.PlatformConfig
import com.kinoshazam.config.getPlatformConfig
import com.kinoshazam.history.TAB_CARTOONS
import com.kinoshazam.history.TAB_FAVORITES
import com.kinoshazam.history.TAB_HOME
import com.kinoshazam.history.TAB_MOVIES
import com.kinoshazam.history.TAB_SERIES
import com.kinoshazam.history.WebMainTab
import com.kinoshazam.screens.main.compact.CompactMainWindow
import com.kinoshazam.screens.main.expanded.ExpandedMainWindow
import com.kinoshazam.screens.main.medium.MediumMainWindow
import org.koin.compose.viewmodel.koinViewModel
import presentation.screens.main.MainMVIAction
import presentation.screens.main.MainState
import presentation.screens.main.MainViewModel
import utils.FormFactor

@Composable
fun MainWindowHost(formFactor: FormFactor) {
    val viewModel = koinViewModel<MainViewModel>()
    val state by viewModel.state.collectAsStateWithLifecycle()

    var userChoseMenu by remember { mutableStateOf(false) }
    val onAction: (MainMVIAction) -> Unit = { action ->
        if (action is MainMVIAction.OnMenuItemClicked) userChoseMenu = true
        viewModel.onAction(action)
    }

    if (getPlatformConfig().platform == PlatformConfig.Platform.WEB) {
        DisposableEffect(viewModel) {
            WebMainTab.bind { tab ->
                tab.toMenuItem()?.let { item ->
                    viewModel.onAction(MainMVIAction.OnMenuItemClicked(item))
                }
            }
            onDispose { WebMainTab.unbind() }
        }
        LaunchedEffect(state.selectedMenu, userChoseMenu) {
            val tab = state.selectedMenu.toWebTab()
            val restored = WebMainTab.current.value
            // The menu starts on home. That default must not overwrite a restored
            // tab before the user actually picks one.
            if (!userChoseMenu && tab == TAB_HOME && restored != TAB_HOME) return@LaunchedEffect
            WebMainTab.report(tab)
        }
    }

    when (formFactor) {
        is FormFactor.Compact -> CompactMainWindow(
            state = state,
            onAction = onAction
        )

        is FormFactor.Medium -> CompactMainWindow(
            state = state,
            onAction = onAction
        )

        is FormFactor.Expanded -> MediumMainWindow(
            state = state,
            onAction = onAction,
        )

        is FormFactor.ExtraLarge -> ExpandedMainWindow(
            state = state,
            onAction = onAction,
        )
    }
}

private fun MainState.MenuItem.toWebTab(): String = when (this) {
    MainState.MenuItem.KINOSHKA -> TAB_HOME
    MainState.MenuItem.FILMS -> TAB_MOVIES
    MainState.MenuItem.TVSHOWS -> TAB_SERIES
    MainState.MenuItem.CARTOONS -> TAB_CARTOONS
    MainState.MenuItem.FAVORITES -> TAB_FAVORITES
}

private fun String.toMenuItem(): MainState.MenuItem? = when (this) {
    TAB_HOME -> MainState.MenuItem.KINOSHKA
    TAB_MOVIES -> MainState.MenuItem.FILMS
    TAB_SERIES -> MainState.MenuItem.TVSHOWS
    TAB_CARTOONS -> MainState.MenuItem.CARTOONS
    TAB_FAVORITES -> MainState.MenuItem.FAVORITES
    else -> null
}
